import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { QueryConfig, ExtractFnReturnType } from "../../../lib/react-query";
import { getClaimFollowUpComments } from "../api/ClaimFollowUpCommentAPI";

type QueryFnTypeClaimFollowUpComment = typeof getClaimFollowUpComments;

export const useClaimFollowUpComment = (
    claimId: number,
    config?: QueryConfig<QueryFnTypeClaimFollowUpComment>
) => {
    return useQuery<ExtractFnReturnType<QueryFnTypeClaimFollowUpComment>>({
        ...config,
        queryKey: ["claimFollowUpComment", claimId, i18n.language],
        queryFn: () => getClaimFollowUpComments(claimId),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!claimId,
    });
};